export default __webpack_public_path__ + "static/media/L_Amandier_argent_porte_cle_coeur.e21c5cc1.png";